/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Monthly_BillingInputs */

const en_pricing_monthly_billing = /** @type {(inputs: Pricing_Monthly_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billed monthly`)
};

const es_pricing_monthly_billing = /** @type {(inputs: Pricing_Monthly_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturación mensual`)
};

/**
* | output |
* | --- |
* | "Billed monthly" |
*
* @param {Pricing_Monthly_BillingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_monthly_billing = /** @type {((inputs?: Pricing_Monthly_BillingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Monthly_BillingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_monthly_billing(inputs)
	return en_pricing_monthly_billing(inputs)
});